
































import Vue from "vue";
import AdminService from "@/services/adminService";

export default Vue.extend({
  name: "IntegrationNumber",

  data() {
    return {
      number: 0,
      show: false,
      updating: false
    };
  },
  async created() {
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const adminService = new AdminService(jwt);
      const response = await adminService.getIntegrationNumber();
      if (response && response.status == 200) {
        this.number = response.data;
        this.show = true;
      }
    }
  },
  methods: {
    async submit(e) {
      this.updating = true;
      e.preventDefault(); // Prevent page from reloading.
      console.log(this.number);
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const adminService = new AdminService(jwt);
        const formData = new FormData();
        formData.append("number", this.number.toString());
        const response = await adminService.updateIntegrationNumber(formData);
        if (response && response.status == 200) {
          if (response.data) {
            this.updating = false;
            alert("Update Successfully");
            await this.$router.push("/admin-panel");
          }
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-panel");
    }
  }
});
